import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=1fa8c026&scoped=true&"
import script from "./CustomField.vue?vue&type=script&lang=ts&"
export * from "./CustomField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8c026",
  null
  
)

export default component.exports